import React from 'react';
import { Button, Flex, InputNumber, Radio, Tabs } from 'antd';
import { CheckOutlined, DeleteOutlined } from '@ant-design/icons';

const NumberingContent = (props) => {
  const items = [
    {
      key: "auto",
      label: "Automatische Nummerierung",
      children: (
        <Flex vertical>
          <p>Typ</p>
          <Radio.Group onChange={(event) => props.setNumbering(event.target.value)} defaultValue="row">
            <Radio value="row">Reihe</Radio>
            <Radio value="block">Block</Radio>
          </Radio.Group>
          <p>Horizontale Richtung</p>
          <Radio.Group
            onChange={(event) => props.setHorizontalNumberingDirection(event.target.value)}
            value={props.horizontalNumberingDirection}
          >
            <Radio value="ltr">Links nach Rechts</Radio>
            <Radio value="rtl">Rechts nach Links</Radio>
          </Radio.Group>
          <p>Vertikale Richtung</p>
          <Radio.Group
            onChange={(event) => props.setVerticalNumberingDirection(event.target.value)}
            value={props.verticalNumberingDirection}
            style={{ marginBottom: 16 }}
          >
            <Radio value="ttb">Oben nach Unten</Radio>
            <Radio value="btt">Unten nach Oben</Radio>
          </Radio.Group>
          <p>Starte Nummerierung mit</p>
          <InputNumber
            min={1}
            max={10000}
            value={props.number}
            onChange={props.setNumber}
          />
          <Button style={{ marginTop: '20px' }} type="primary" icon={<CheckOutlined />} onClick={() => {
            switch (props.numbering) {
              case 'row':
                props.numberSeatsPerRow(props.number);
                break;
              case 'block':
                props.numberSeatsPerBlock(props.number);
                break;
              default:
                console.log('Error in numbering content');
            }
          }}
          >
            <p>Anwenden</p>
          </Button>
          <Button style={{ marginTop: '20px' }} type="secondary" icon={<DeleteOutlined />}
                  onClick={props.clearNumbering}>
            <p>Löschen</p>
          </Button>
        </Flex>
      )
    },
    {
      key: 'custom',
      label: 'Manuelle Nummerierung',
      children: (
        <Flex vertical>
          <p>Nummer</p>
          <InputNumber
            min={0}
            max={100}
            value={props.number}
            onChange={props.setNumber} />
          <Button style={{ marginTop: '20px' }} type="primary" icon={<CheckOutlined />} onClick={() => {
            props.numberSeatsPerRow(props.number, true)
          }}
          >
            <p>Anwenden</p>
          </Button>
          <Button style={{ marginTop: '20px' }} type="secondary" icon={<DeleteOutlined />}
                  onClick={props.clearNumbering}>
            <p>Löschen</p>
          </Button>
        </Flex>
      )
    }

  ]


  return (
    <Tabs defaultActiveKey="1" items={items}/>
  );
}

export default NumberingContent;
